import apiClient, { extractData, handleApiError } from './api.js';

export class CustomerOrderService {
  /**
   * Get public menu items for a given outlet slug
   * GET /api/v1/menu-items/public?outlet_slug=...
   */
  static async getPublicMenu(outletSlug) {
    try {
      const response = await apiClient.get('/menu-items/public', {
        params: { outlet_slug: outletSlug },
      });
      return extractData(response);
    } catch (error) {
      console.error('Error fetching public menu:', error);
      throw new Error(handleApiError(error));
    }
  }

  /**
   * Place an order as a customer
   * POST /api/v1/orders
   */
  static async placeOrder({ outletId, items, sessionId, tableNumber, customerId }) {
    try {
      const response = await apiClient.post('/orders', {
        outlet_id: outletId,
        cart_list: items,
        source: 'customer',
        table_number: tableNumber,
        customer_id: customerId,
        session_id: sessionId,
      });
      return extractData(response);
    } catch (error) {
      console.error('Error placing customer order:', error);
      throw new Error(handleApiError(error));
    }
  }

  /**
   * Add more items to an existing order
   * POST /api/v1/orders/{orderNum}/items
   */
  static async addItemsToOrder(orderNum, { outletId, sessionId, items }) {
    try {
      const response = await apiClient.post(`/orders/${orderNum}/items`, {
        outlet_id: outletId,
        session_id: sessionId,
        items,
      });
      return extractData(response);
    } catch (error) {
      console.error('Error adding items to order:', error);
      throw new Error(handleApiError(error));
    }
  }

  /**
   * Get order by session (customer tracking)
   * GET /api/v1/orders/by-session/{sessionId}
   */
  static async getOrderBySession(sessionId) {
    try {
      const response = await apiClient.get(`/orders/by-session/${sessionId}`);
      return extractData(response);
    } catch (error) {
      console.error('Error fetching order by session:', error);
      throw new Error(handleApiError(error));
    }
  }
}
